<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/Members/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'members'
    }
  },

  created () {
    this.$store.dispatch(`${this.modelName}/getItems`)
  }
}
</script>
